Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TwitterHashtagButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _generalObserver = require("../general-observer");
var _utils = require("./utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var TwitterHashtagButton = function TwitterHashtagButton(_ref) {
  var hashtag = _ref.hashtag,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    onEnter: function onEnter() {
      return (0, _utils.handleTwttrLoad)();
    }
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-testid": "twitter-hashtag-button",
    href: "https://twitter.com/intent/tweet?button_hashtag=".concat(hashtag, "&ref_src=twsrc%5Etfw"),
    className: "twitter-hashtag-button twitter-hashtag-button-mdx-embed",
    "data-size": size
  }, "Tweet #".concat(hashtag)));
};
exports.TwitterHashtagButton = TwitterHashtagButton;